import { INTERFACE } from '@/utils/INTERFACE';
import http from '@/utils/http';
import toast from '@/v-ui/Toast'
import Queue from '@/utils/queue';
import $ from 'jquery';
import manager from '../manager';
import { getParams } from '@/utils/zgb'
import {loginJump} from '@/utils/login'

async function getCouponStatus(arr) {

    const couponLinkList = arr.map(v => JSON.parse(v));

    var res = await http.jsonp.get(`//zgbgw.m.jd.com/one.couponsByLink`, getParams({
        couponLinkList,
    }));
    let result = {};
    if (res.data) {
        result = res.data.coupons.reduce((acc, v, i) => {
            acc[JSON.stringify(couponLinkList[i])] = v;
            return acc;
        }, {})
    }
    return result;
}

const couponStatusQueue = new Queue(getCouponStatus)

async function refresh(ruleId, key) {
    const Handlebars = (await
        import ('@/lib/handlebars')).default;

    const tpl = $(this.dom).find(".tpl").html();
    const render = Handlebars.compile(tpl);

    let data;
    // 初始化mock数据
    if (ruleId === '-1') {
        data = {
            "beginTime": 1514764800000,
            "couponState": 0,
            "discount": 9999,
            "endTime": 1577750400000,
            "limitStr": "优惠券限品类说明",
            "quota": 9999,
        }
    } else {
        data = await getCouponInfo(ruleId, key);
    }

    data = change(data);

    const rendered = render(data);
    $(this.dom).find(".tpl-target").html(rendered);


    async function getCouponInfo(ruleId, key) {
        const result = await couponStatusQueue.get(JSON.stringify({ ruleId, key }));
        return result;
    }

    function change(data) {
        const result = data;

        // 转化时间戳为字符串
        result.beginTimeStr = timestampToTime(data.beginTime);
        result.endTimeStr = timestampToTime(data.endTime);
        data.couponState === undefined && (data.couponState = 0);

        // 优惠券状态文案
        switch (data.couponState) {
            case 1:
                result.couponStateStr = '已领取';
                break;
            case 2:
                result.couponStateStr = '已抢光';
                break;
            case 0:
            default:
                result.couponStateStr = '未领取';
        }

        return result;

        function timestampToTime(timestamp) {
            let date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
            let Y = date.getFullYear() + '-';
            let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
            let D = date.getDate() < 10 ? `0${date.getDate()} ` : `${date.getDate()} `;
            return Y + M + D;
        }
    }
}


manager.add('coupon2.status', {
    async created(ruleId, key) {

        refresh.call(this, ruleId, key);

    }
})

manager.add('coupon2.get', {
    async created(ruleId, key) {
        $(this.dom).on('click', async() => {
            let result = await getCoupon();
            // 未登录
            if (result.code === '3') {
                loginJump()
            } else {
                result = result.data;
                if (result.success === true) {
                    toast('领取成功');
                    refresh.call(this, ruleId, key);
                } else {
                    toast(result.resultMsg || result.msg);
                }
            }

            async function getCoupon() {
                const result = await http.jsonp.get(INTERFACE().fetchCoupon, getParams({
                    ruleId,
                    key,
                }));
                return result;
            }
        })
    },
    destroyed() {
        $(this.dom).off("click")
    }
})